import { useEffect } from "react";
import { useAtomValue } from "@effect-atom/atom-react";
import { darkModeAtom } from "../atoms";

export function useDarkMode() {
  const darkMode = useAtomValue(darkModeAtom);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  return darkMode;
}
